import { Outlet } from "react-router-dom";
//AntDesign Cofig Imports
import { ConfigProvider } from "antd";

//Set Persian Interface
import localeValues from "antd/es/locale/fa_IR";

//Set Jalali Calender
// import {JalaliLocaleListener} from 'antd-jalali'
ConfigProvider.config({
  theme: {
    primaryColor: "#1890ff",
  },
});
const Root = () => {
  return (
    <ConfigProvider direction="rtl" locale={localeValues}>
      <Outlet />
    </ConfigProvider>
  );
};
export default Root;
